export default __webpack_public_path__ + "static/media/CompletedTick.997be658.svg";